<template>
<base-layout>
  <div class="back-button-div">
  <ob-button @click="ShowWarningPopup = true" type="link"> <i aria-hidden="true" class="fa fa-chevron-left"></i> Back</ob-button>
  </div>
  <div style="height:100%">
     <div id="pdf-view"></div>
    <ob-modal2 :show.sync="showConsentPopup" :backdrop="false" :type="1" width="45%" >
                <div style="padding:25px;">
                    <div class="modal-soc--body" style="padding:30px 15px;text-align:center">
                    <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/FormI539/warning.svg`"  slot="reference" />
                        <br>
                    <h3 style='color:#d0021b;margin-top:25px;font-size:18px;font-weight:600'> Save Form </h3>
                    <br>
                        <div>
                            <!-- <p class="agreeCondition">The employment start date for this employee is in future, and the Form I-9 is completed.<br>
                            Updating the work authorization will delete the existing Form I-9.<br>
                            You'll have to re-initiate Form I-9 with the Work Authorization Document.</p>
                            <p class="agreeCondition" style="margin-bottom:20px;">Do you wish to proceed? </p>
                            <i style='font-size: 11px;'>*Entire Form I-9 and its components including Audit Trail, will be deleted permanently. </i>
                            <div class="checkbox-inline" style="color: #143361;font-size: 12px;">
                                    <ob-checkbox v-model="isAgree" :val="1">I've read understood the above mentioned conditions.</ob-checkbox>
                            </div> -->
                            <p style="color:#333232;font-size:13px;font-weight:600">"Save as Draft" if you would like to save the information and finish filling the form later.</p>
                            <p style="color:#333232;font-size:13px;font-weight:600;padding-top: 5px">"Mark as Complete" if you have completed the form. You cannot update it later.</p>
                             <ob-checkbox style="padding-top: 10px" :val="1" class="checkbox-style" v-model="checkboxVal">I acknowledge that I have completed the form with the appropriate information.</ob-checkbox>

                        </div>
                    </div>
                    <div class="modal-soc--footer" style="padding: 0px 20px 0px 20px;text-align:center;">
                        <ob-button style="margin-right:14px;" type="secondary" @click="cancelPopup">Back</ob-button>
                        <ob-button style="margin-right:14px;" type="secondary" @click="saveFileObject(true)" :disabled="checkboxVal">Save as Draft</ob-button>
                        <ob-button @click="saveFileObject(false)" :disabled="!checkboxVal">Mark as Complete</ob-button>
                    </div>
                </div>
            </ob-modal2>
            <ob-modal2 :show="OpenWarningPop" :type="1" width="45%" :backdrop="false">
            <div style="padding:25px;">
                <div class="col-md-12 " style="padding:30px 15px;text-align:center">
                    <img class="delimg" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/warning-red-alert.svg`" />
                </div>
                 <center>
                   <p class="title-content">Request Canceled by your employer !</p>
                   <div style="padding:10px;width:85%">
                  <p class="title-content1">Your Employer has cancelled the request to fill this form.</p>
                 </div>
                 <ob-button type="primary"  class="btnn" @click="OnGotIt()">Got it</ob-button> 
                 </center>
            </div>
        </ob-modal2>
         <ob-modal2 :show.sync="ShowWarningPopup" :backdrop="false" :type="1" width="45%" >
                <div style="padding:25px;">
                    <div class="modal-soc--body" style="padding:30px 15px;text-align:center">
                    <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/FormI539/warning.svg`"  slot="reference" />
                        <br>
                    <h3 style='color:#ce2451;margin-top:25px;font-size:18px;font-weight:600'> Are you sure you want to leave the page?</h3>
                    <br>
                        <div>
                            <p style="color:#333232;font-size:13px;font-weight:600">If you leave the page without saving the changes, the data may not be saved.</p>

                        </div>
                    </div>
                    <div class="modal-soc--footer" style="padding: 0px 20px 0px 20px;text-align:center;">
                       <ob-button style="margin-right:14px;width:70px" type="secondary" @click="goBackToI539">Leave</ob-button>
                            <ob-button style="width:70px" @click="ShowWarningPopup = false">Stay</ob-button>
                    </div>
                </div>
            </ob-modal2>
            <ob-modal2 :show.sync="showRequestCancelledPopup" :backdrop="false" :type="1" width="45%" >
                <div style="padding:25px;">
                    <div class="modal-soc--body" style="padding:30px 15px;text-align:center">
                    <img style="height: 45px;" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/info_red_icon.svg`"  slot="reference" />
                        <br>
                    <h3 style='color:#ce2451;margin-top:25px;font-size:18px;font-weight:600'> Request Canceled by your employer!</h3>
                    <br>
                        <div>
                            <p style="color:#333232;font-size:13px;font-weight:600">Your Employer has canceled the request to fill this form.</p>

                        </div>
                    </div>
                    <div class="modal-soc--footer" style="padding: 0px 20px 0px 20px;text-align:center;">
                       <ob-button style="margin-right:14px;width:70px"  @click="goBackToI539">Got it</ob-button>
                            <!-- <ob-button style="width:70px" @click="ShowWarningPopup = false">Stay</ob-button> -->
                    </div>
                </div>
            </ob-modal2>
    </div>
</base-layout>
</template>
 <script src="https://documentcloud.adobe.com/view-sdk/main.js"></script>
 <script>
  import c from 'Vue/Core/constants.js';
 export default {
    props:['pdfFormUrl'],
     data(){
      return {
          pdfAPIReady:false,
          adobeDCView:null,
          fileObject:'',
          showConsentPopup:false,
          checkboxVal:false,
          DraftCase:'',
          OpenWarningPop:false,
          ShowWarningPopup:false,
          setWatcher:'',
          showRequestCancelledPopup:false
      }
     },
     created(){
         if (window.AdobeDC) {
               this.pdfAPIReady = true
          }else{
            /* Wait for Adobe Document Services PDF Embed API to be ready */
            document.addEventListener("adobe_dc_view_sdk.ready", () => { 
                // previewFile();
                this.pdfAPIReady = true
            });
          }
     },
     mounted(){
       this.setWatcher = window.setInterval(() => { 
        this.checkIfHRCancelledRequest()
       }, 15000) 
     },
 watch: {
    pdfAPIReady(val) {
      // should only be called when true, but be sure
      var config = {
		   embedMode: "FULL_WINDOW",
		  showLeftHandPanel: true,
		  showAnnotationTools: true,
		  showDownloadPDF: true, 
		  showPrintPDF: true,
		  showPageControls: true,
      enableFormFilling:true
	  };
      if(val) { 
        var adobeDCView = new AdobeDC.View({
          clientId: c.PDFEMBEDAPICLIENTKEY, 
          divId: "pdf-view"
        });//d5a0d0cd201c48859e73b03a2b4e9162
        
        var URL = this.pdfFormUrl
        // if(localStorage.getItem('i539-pdf') != '' && localStorage.getItem('i539-pdf') != undefined ){
        //          URL =  localStorage.getItem('i539-pdf')
        // }
        // else{
        //   if(this.$route.params.type=='I539')
        //       {
        //     URL = 'https://dev-filesystem-api.onblick.com/File/a5a28650-97c5-489a-b219-2e5db501ac08obk.pdf'
        //       }
        //     else{
        //     URL = 'https://dev-filesystem-api.onblick.com/File/f5c0b7c5-e74b-4d59-a6d4-3d991c59e9aeobk.pdf'
        //     }
        // }

      //    adobeDCView.previewFile(
      //  {
      //    // content:{location: {url: "/Content/BodeaBrochure.pdf"}},
      //    content:{location: {url: URL}},
      //     metaData: {fileName: "FORM I-539.pdf"}
      //  },config);
          
        var accessToken = localStorage.getItem('access_token');
            const authHeader = `Bearer ${accessToken}`;
            axios({
                url: `${c.I539BASEURL}/api/File?url=${URL}`,
                method: 'GET',
                responseType: 'blob',
                headers: {
                    'Authorization': authHeader,
                    'Content-Type': 'application/json',
                        'Accept': 'application/pdf'
                },
            }).then((response) => { 
                  var pdfArrayBuffer = ''
                  var blob = new Blob([response.data], {type: 'application/pdf'});

                  new Response(blob).arrayBuffer()
                    .then((blobres) => {
                      pdfArrayBuffer = blobres
                      if(this.$route.params.type=='I539')
                        {
                          adobeDCView.previewFile(
                            {
                              // content:{location: {url: "/Content/BodeaBrochure.pdf"}},
                              //content:{location: {url:'https://dev-filesystem-api.onblick.com/File/a5a28650-97c5-489a-b219-2e5db501ac08obk.pdf'}},
                                content: { promise: Promise.resolve(pdfArrayBuffer) },
                                metaData: {fileName: "FORM I-539.pdf"}
                            },config);
                        }else{
                        // var URLTEMP = 'https://dev-filesystem-api.onblick.com/File/f5c0b7c5-e74b-4d59-a6d4-3d991c59e9aeobk.pdf'
                          adobeDCView.previewFile(
                            {
                              // content:{location: {url: "/Content/BodeaBrochure.pdf"}},
                              content: { promise: Promise.resolve(pdfArrayBuffer) },
                                metaData: {fileName: `FORM I-539${this.$route.params.index}.pdf`}
                            },config);

                        }
                    });
            });

       var _this = this

        adobeDCView.registerCallback(
        AdobeDC.View.Enum.CallbackType.SAVE_API,
        function(metaData, content, options) {
        _this.showConsentPopup = true
   
      /* Write down your own save implementation here... and based on that resolve or reject response in given format */
     
     //var base64PDF = arrayBufferToBase64(content);
      var binary = '';
       var bytes = new Uint8Array( content );
      // var len = bytes.byteLength;
      // for (var i = 0; i < len; i++) {
      //     binary += String.fromCharCode( bytes[ i ] );
      // }
      // var base64PDF = window.btoa( binary );
      var blob=new Blob([bytes], {type: "application/pdf"});// change resultByte to bytes

      // var link=document.createElement('a');
      // link.href=window.URL.createObjectURL(blob);
      // link.download="myFileName.pdf";
      // link.click();

      // blob.lastModifiedDate = new Date();
      //     blob.name = "test.pdf";

          //let file = new File(content, "test.pdf", { type: "application/pdf" });
        // var file = new File(blob, "test.pdf");
        
        _this.fileObject = new File([blob], "test.pdf", { lastModified: new Date().getTime(), type: blob.type })
          // let fileListVal = new FileList();
          // fileListVal.push(file);

         

    //var fileURL = "data:application/pdf;base64," + base64PDF;
     /* Save callback success case */
      return new Promise((resolve, reject) => {
         resolve({
            code: AdobeDC.View.Enum.ApiResponseCode.SUCCESS,
            data: { 
              metaData: Object.assign(metaData, {fileName: ''})
            }
         });
      });
   });

       /* Options to control save behavior */
// const saveOptions = {
//    autoSaveFrequency: <Number, default=0>,
//    enableFocusPolling: <Boolean, default=false>,
//    showSaveButton: <Boolean, default=true>
// }


      }
    }
  },
  methods:{
    cancelPopup(){
      this.showConsentPopup = false
    },
    checkIfHRCancelledRequest(){
      ajax.get(`FormI539/${this.$route.params.id}/Workflow`, {}, (res) => {
      if(res.status == 200){
        if(res.data.status != 'Request_Employee_To_Fill' && res.data.status != 'Request_Employee_To_Review_And_Upload' && res.data.status != 'InProgress' && res.data.status != 'Resent_Request'){
        this.showRequestCancelledPopup = true
        }
      }
      },{},'FormI539')

    },
    goBackToI539(){
     let url = `${c.APPLICATIONBASEURL}/employee/form-i539`;
                            window.open(url, "_self");
    },
     saveFileObject(isDraft){
       // let fileListVal = new FileList();
          // fileListVal.push(file);
          this.DraftCase=isDraft
         this.$loading({ 'loadingText': 'Saving...' })
         var accessToken = localStorage.getItem('access_token')

                let formdata = new FormData();

                formdata.append("fileList", this.fileObject);

                var ajax = new XMLHttpRequest();
                ajax.upload.addEventListener("progress", this.progressHandler);
                ajax.addEventListener("load", this.completeHandler);
                ajax.addEventListener("error", this.errorHandler);
                ajax.addEventListener("abort", this.abortHandler);
                
                 if(this.$route.params.type=='I539')
                {
                  ajax.open("POST", `${c.I539BASEURL}/api/FormI539/${this.$route.params.id}/Pdf/Complete?isDraft=${isDraft}`);
                }
                else{
                  ajax.open("POST", `${c.I539BASEURL}/api/FormI539A/${this.$route.params.id}/Pdf/Complete?isDraft=${isDraft}`);
                }
               // ajax.open("POST", `${c.I539BASEURL}/api/FormI539/${this.$route.params.id}/Pdf/Complete?isDraft=${isDraft}`);
                if (accessToken !== null) {
                    ajax.setRequestHeader('Authorization','Bearer '+ accessToken);
                }
                ajax.setRequestHeader('Accept', 'application/json');
               //ajax.setRequestHeader('Accept', '*/*');
               //ajax.setRequestHeader('Content-Type', 'multipart/form-data');
              // ajax.setRequestHeader('Content-Type', 'multipart/form-data; boundary=--------------------------122674650717831677858548');
                ajax.send(formdata);
    },
    completeHandler(res){
          var response = JSON.parse(res.currentTarget.response);
          if(response.state == true){
              if(this.DraftCase==true){
                if(this.$route.params.type=='I539'){
                  this.$message({
                    type: 'success',
                    message: 'Form I-539 Saved Successfully'
                  })
                }
                else{
                  this.$message({
                    type: 'success',
                    message: `Form I-539${this.$route.params.index} Saved Successfully`
                  })
                }
              }
              else{
                if(this.$route.params.type=='I539'){
                  this.$message({
                    type: 'success',
                    message: 'Form I-539 Completed Successfully'
                  })
                }
                else{
                  this.$message({
                    type: 'success',
                    message: `Form I-539${this.$route.params.index} Completed Successfully`
                  })
                }
              }
            let url = `${c.APPLICATIONBASEURL}/employee/form-i539`;
                            window.open(url, "_self");
          }else{
            if(response.message=="Not authorized to fill"){
              this.OpenWarningPop=true
            }
            else{
              this.$message({
                  type: "error",
                  message: response.message
              });
            }
              
              this.cancelPopup()
          }
           this.$loading({}).close()
         
     },
            errorHandler(){
                //Console.log('error');
            },
      OnGotIt(){
        this.OpenWarningPop=false
        let url = `${c.APPLICATIONBASEURL}/employee/form-i539`;
                            window.open(url, "_self");
      }
  }
 }
    
 </script>
 <style lang="scss" scoped>

.btnn
{
    text-align: center;
    margin-top: 40px;
    margin-bottom: 30px;
    padding-left:5%;
    padding-right: 5%;
   }
.title-content {
    
  color:#d0021b;
  margin-top:30px;
  font-size:14px;
  font-weight:600
  }
  .title-content1{
  font-size:12px;
  font-weight:600
  }
  .back-button-div{
    box-shadow: #ddd 0px 1px 1px;
    border-bottom: 1px solid #ddd;
    margin-bottom: 4px;
 }
</style>


// WEBPACK FOOTER //
// src/components/ESSProfile/FormI539/FormI539PDF.vue